import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/GetRoadsheet'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class GetRoadsheetStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "GetRoadsheetStore",
			variables: true,
		})
	}
}

export async function load_GetRoadsheet(params) {
  await initClient()

	const store = new GetRoadsheetStore()

	await store.fetch(params)

	return {
		GetRoadsheet: store,
	}
}
